import { ContactsRequest, Api, ContactsResponse } from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: Api };
type HookTuple = [
  response: ContactsResponse | undefined,
  fetchData: (params: ContactsRequest) => void,
  reset: () => void,
  fetchContacts: (params: ContactsRequest) => Promise<ContactsResponse>,
];
type ApiHook = (props: HookProps) => HookTuple;

const useFetchContacts: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [params, setParams] = useState<ContactsRequest>();
  const [response, setResponse] = useState<ContactsResponse>();
  const [shouldFetchData, setShouldFetchData] = useState(false);
  const source = axios.CancelToken.source();
  useEffect(() => {
    if (!shouldFetchData) return () => {};

    const loadData = async (_params: ContactsRequest) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');
      const res = await api.fetchContacts(_params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };
    if (shouldFetchData && params) void loadData(params);
    setShouldFetchData(false);
    return () => {
      source.cancel();
    };
  }, [shouldFetchData]);

  return [
    response,
    (_params: ContactsRequest) => {
      setParams(_params);
      setShouldFetchData(true);
    },
    () => {
      setResponse(undefined);
      setShouldFetchData(false);
    },
    (_params: ContactsRequest) => api.fetchContacts(_params, source),
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(useFetchContacts);
